// extracted by mini-css-extract-plugin
module.exports = {"title":"Share_title__7lfVt","list":"Share_list__d1ozv","item":"Share_item__nINae","vk":"Share_vk__Ky_vQ","fb":"Share_fb__9iHGt","load":"Share_load__X52p5"};